/* see lightbox.js
accountCredits.js
*/

(function () {
    const isSecureURL = location.href.indexOf('secure.') > -1;
    const isCheckOutURL = location.href.indexOf('givingCart.html') > -1;

    // Used in lots of JS and JSP
    window.toggleSignInOverlay = function (event, forceOverlay, data) {
        if (!forceOverlay && !isCheckOutURL && (isSecureURL || (typeof headerType !== 'undefined' && (headerType == 'iframeHeader' || headerType == 'cart')))) {
            return;
        }

        toggleSignInOverlayInternal(data, event);
    };

    // Used in a couple of JS files
    window.toggleCartSignInOverlay = function (forceOverlay, data) {
        if (!forceOverlay && (isSecureURL || (typeof headerType !== 'undefined' && (headerType == 'iframeHeader' || headerType == 'cart')))) {
            return;
        }

        toggleSignInOverlayInternal(data);
    };

    // Used in a couple of JS files
    window.toggleContactFormSignInOverlay = function (forceOverlay, data) {
        if (!forceOverlay && (isSecureURL || (typeof headerType !== 'undefined' && (headerType == 'iframeHeader' || headerType == 'cart')))) {
            return;
        }

        toggleSignInOverlayInternal(data);
    };

    function toggleSignInOverlayInternal(data, event) {
        if (window.signinOverlay2Part) {
            if (event) {
                event.preventDefault();
            }

            const { username, first, signinStatus } = (data && data.user) || {};
            window.signinOverlay2Part.toggleSignin(username, first, signinStatus);
        }
    }

    function teacherHasAuthorityToUploadProfilePhoto() {
        if (!window.isLoggedInOrRemembered()) {
            return false;
        }
        // [2017-02-02, BGK] for Teacher Profile and Project Page
        if (typeof teacherId !== 'undefined' && userId != teacherId) {
            return false;
        }
        // [2017-02-02, BGK] for Giving Page
        if (typeof challenge !== 'undefined' && typeof challenge.donorId !== 'undefined' && userId != challenge.donorId) {
            return false;
        }
        return true;
    }

    // Used in several JS files
    window.toggleTeacherProfilePhotoUploadOverlay = function (event) {
        // make sure teacher can't upload photo if they signed out in an another tab
        $(window).off('userCookiesReset.toggleTeacherProfilePhotoUploadOverlay');
        if (!teacherHasAuthorityToUploadProfilePhoto()) {
            window.toggleSignInOverlay(null, true);
            $(window).on('userCookiesReset.toggleTeacherProfilePhotoUploadOverlay', function () { toggleTeacherProfilePhotoUploadOverlay(event); });
            return;
        }
        if (event) {
            event.preventDefault ? event.preventDefault() : event.returnValue = false;
        }

        // no overlay on mobile
        if (window.isMobileView()) {
            location.href = secureBaseURL + 'teacher/profile_photo_upload.html?endpointURL=' + encodeURIComponent(location.href);
            return;
        }
        const iframeId = 'teacher-profile-photo-overlay-iframe';
        if ($('#' + iframeId).length === 0) {
            toggleAndPositionScreenAndOverlayIframe(iframeId, secureBaseURL + 'teacher/profile_photo_upload.html', event);
            $('.overlay-iframe-wrapper').addClass('overlay').addClass('large');
        }
    };

    // Used as a target for parent.postMessage
    window.refreshHeaderAccountPhoto = function () {
        // the account photo in the header comes from the 'userId'
        // cookie, so to refresh this photo, we re-obtain the cookie.
        const url = secureBaseURL + 'common/reset_user_cookie.html';
        if (isSecureURL) {
            $.get(url, refreshHeaderAccountPhotoCallback);
        } else {
            $.ajax({
                url,
                dataType: 'jsonp',
                jsonpCallback: 'refreshHeaderAccountPhotoCallback',
            });
        }
    };

    // Needs to be global for JSONP
    window.refreshHeaderAccountPhotoCallback = function () {
        window.setUpUserCookies();
        showSignOutLink();
    };

    /**
     * Adds the account dropdown to the header
     *
     * This is called from many files, including JSPs
     * It's the main reason we can't conver header2.js to more of a module
     */
    window.showSignOutLink = function () {
        if (window.isNonBlankCookie('headerinfo')) {
            if (window.isUserTypeTeacher()) {
                $('#main-header').removeClass().addClass('teacher');
            } else {
                $('#main-header').removeClass().addClass('donor');

                if (userObj.isVIP == true) {
                    $('#main-header').addClass('vip');
                    $('#mainHeader').addClass('vip');
                }
            }

            if (userName) {
                $('#user-account-links .greetings').text(userName);
            }
            if (userObj && userObj.userPhotoURL) {
                const userPhotoURL = userObj.userPhotoURL;
                $('#header-account-photo').remove();
                $('#user-account-links .greetings').before('<div id="header-account-photo"><img alt="Your profile photo" src="' + ((userPhotoURL.indexOf('http') == -1) ? secureS3URL : '') + userPhotoURL + '"></div>');
            }
            if (userId) {
                const hasTeacherStats = userObj && userObj.hasTeacherStats;
                const data = { userId, userType, headerType: 'Header', hasTeacherStats };
                const templateV = Handlebars.templates['headerDonorTabs.tmpl'];
                const htmlV = templateV(data);
                if ($('#user-account-links .donor-tabs').length == 0) {
                    $('#user-account-links .account').append(htmlV);
                } else {
                    $('#user-account-links .donor-tabs').replaceWith(htmlV);
                }
                addEventHandlersToUserTabs('Header', userType);
                if (userHasProjectRefundChoices) {
                    $('#account-trigger').addClass('badge');
                    $('#user-account-links .donor-tabs li.private-info').addClass('badge');
                } else {
                    $('#account-trigger').removeClass('badge');
                    $('#user-account-links .donor-tabs li.private-info').removeClass('badge');
                }
                if (userHasPendingCheckPledges) {
                    $('#account-trigger').addClass('badge');
                    $('#user-account-links .donor-tabs li.private-info').addClass('badge');
                }
                highlightAccountDropdownElements();
                displayAccountCreditsTip();
            }
        } else {
            $('#main-header').removeClass();
        }

        showHideTeacherEmailConfirmBanner();

        showHideTeacherSchoolEmailConfirmBanner();

        if (shouldShowAmbassadorBanner()) {
            $('.js-teacher-ambassador-banner').show();
        }

        $(document).trigger('loginAttempted');
    };

    // Only used in general.js
    window.showHideTeacherEmailConfirmBanner = function () {
        if (window.isNonBlankCookie('teacherEmailConfirm') && readCookie('teacherEmailConfirm') == 'true') {
            $('#teacher-email-confirm-banner').show();
            $('#teacher-banner').hide();
        } else {
            $('#teacher-email-confirm-banner').hide();
        }
    };

    // Only used in general.js
    window.showHideTeacherSchoolEmailConfirmBanner = function () {
        if (window.isNonBlankCookie('teacherSchoolEmailConfirm') && readCookie('teacherSchoolEmailConfirm') === 'true') {
            $('#teacher-school-email-confirm-banner').show();
            $('#teacher-school-email-confirm-banner .screen').addClass('on');
            $('#teacher-school-email-confirm-banner .overlay').addClass('on');
            $('#teacher-banner').hide();
        } else {
            $('#teacher-school-email-confirm-banner').hide();
        }
    };

    window.hideAccountDropdowns = function () {
        $('#teacher-account-links .subnav').hide();
        $('#user-account-links .subnav').hide();
        $('#account-trigger').removeClass('triggered');
        $('#classroom-trigger').removeClass('triggered');
    };

    // same as signout
    // noinspection JSUnusedGlobalSymbols
    function notYou(event) {
        eraseCookie('userId');
        resetUserVariables();
        eraseCookie('cartUUID');
        eraseCookie('accountCredits');
        eraseCookie('cartGiftCodeAmount');
        eraseCookie('headerinfo');
        resetMiniCartForSignOut();
        removeFavorites();
        displayAccountCreditsTip(); // hide account credits tip
        showSignOutLink();
        window.hideAccountDropdowns();
        if (window.signinOverlay2Part) {
            window.signinOverlay2Part.reinitialize();
        }

        if (event) event.preventDefault ? event.preventDefault() : event.returnValue = false;
        getURLInHiddenIframe(secureBaseURL + 'common/signout.html', 'notYouIframe');
    }

    // Called via parent.postMessage from thirdpartycleanup.jsp
    window.notYouCallback = function () {
        if (isSecureURL || qsParam.view == 'owner') {
            location.href = baseURL;
        } else {
            $(window).trigger('signoutTriggered');
            window.resetAndPersonalizeHeaderElements();
        }
    };

    // Used by a few JS files
    window.setHeaderMMILink = function () {
        if (readCookie('favCookiesSet') != null) {
            if (readCookie('favCookiesSet') == 'true') {
                $('.donor-tabs .favorites').addClass('on');
            } else {
                $('.donor-tabs .favorites').removeClass('on');
            }
        }
        if (isNonBlankCookie('hasViewableGPs') && readCookie('hasViewableGPs') == 'true') {
            $('.donor-tabs .donor-campaigns').addClass('on');
        } else {
            $('.donor-tabs .donor-campaigns').removeClass('on');
        }
    };

    function highlightAccountDropdownElements() {
        if (readCookie('favCookiesSet') != null) {
            setHeaderMMILink(true);
        } else if (readCookie('userId') != null && readCookie('userId') != '') {
            updateFavoritesCookie();
        }
    }

    $(document).on('updateFavoritesCookie', function () {
        setHeaderMMILink(true);
    });

    window.personalizeHeaderElements = function () {
        refreshMiniCartFromServerOrLocalStorage();
        showSignOutLink();
    };

    window.resetAndPersonalizeHeaderElements = function () {
        window.setUpUserCookies();
        window.personalizeHeaderElements();
        window.refreshAccountCredits();
    };

    // Used in a couple of JS
    window.addEventHandlersToUserTabs = function (headerType, userType) {
        $('.js-donor-tabs .js-sign-out').on('click', function (event) {
            notYou(event);
        });
    };

    // HOW IT WORKS

    if (readCookie('hasHeaderHIW') == null) {
        createCookie('hasHeaderHIW', 'true', 0);
    } else if (readCookie('hasHeaderHIW').length < 8) {
        createCookie('hasHeaderHIW', readCookie('hasHeaderHIW') + '1', 0);
    }
})();
